fragment ProjectFragment on Project {
  Id
  Name
  Description
  ProjectTypeCode
  ProjectType {
    Code
    Name
    Description
  }
  PermissionTypeCode
  TenantId
  CreatedByUserId
  CreatedByUser {
    FirstName
    LastName
  }
  UpdatedByUserId
  UpdatedByUser {
    FirstName
    LastName
  }
  UpdatedAt
  CreatedAt
  IsArchived
  IsDeleted
  IsFavorite
  AssetCode
  Icon {
    Code
    Name
    Path
  }
  IsNotify_Email
  PublicJournal_Properties
  PublicJournal_Areas
  PublicJournal_Words
}
